import { render, staticRenderFns } from "./ComponentLargeExposureChart.vue?vue&type=template&id=20b801e4"
import script from "./ComponentLargeExposureChart.vue?vue&type=script&lang=js"
export * from "./ComponentLargeExposureChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports